import type { CartStateGetSet } from "@/cart/types";
import GRAPHQL_CLIENT from "@/graphql/client";
import type { Cart } from "@/graphql/storefront/generated";

export const addDiscountCode = ({ get, set }: CartStateGetSet) => {
  return async (discountCode: string) => {
    let { cartId, cart: currentCart } = get();

    if (!cartId) {
      const { cartCreate } = await GRAPHQL_CLIENT.CartCreate({
        input: { lines: [] },
      });

      const cart = cartCreate?.cart as Cart;
      cartId = cart.id;
      currentCart = cart;
    }

    const existingCodes =
      currentCart?.discountCodes?.map((dc) => dc.code) || [];
    const { cartDiscountCodesUpdate } = await GRAPHQL_CLIENT.AddDiscountCodes({
      cartId,
      discountCodes: [...existingCodes, discountCode],
    });

    const cart = cartDiscountCodesUpdate?.cart as Cart;

    if (!cart) {
      console.log("error");
      throw new Error("addDiscountCode: Adding discount code to cart failed");
    }

    set({ cartId: cart.id, cart });
  };
};
